import { useState } from "react";
import { Box, Stack, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useDispatch } from "react-redux";
import { LAYOUT_MARGIN } from "Configs/home";

import useWindowSize from "Hooks/useWindowSize";
import { useAppSelector } from "Hooks/useRedux";

import SortStations from "../SortStations";
import Toolbox from "./Toolbox";
import Tooltip from "../Tooltip";
import Operation from "../Operation";
import Pin from "../Map/pin";
import AddSurvay from "../Map/addSurvay";
import AddStation from "../Map/addStation";
import { Spectrum, Spectrum2, Spectrum3 } from "../Map/Spectrum";
import ShowPaths from "../side/rightSide/showPaths";
import Inventory from "../side/rightSide2/inventory";
import Tickets from "../side/rightSide/tickets";
import TicketDetail from "../side/leftSide/TicketDetail";
import LocationData from "../LocationData";
import Menu from "../Menu";
import Modals from "../Modals";
import RightSideController from "./side/rightSideControl";
import LeftSideController from "./side/leftSideController";
import SimpleDashboard from "../side/leftSide/simpleDashboard";

export default function Reports() {
  const { width, height } = useWindowSize();
  const { surveyShowType, visible: surveysVisible, pointwiseShow } = useAppSelector((state) => state.surveys);
  const { fullScreen } = useAppSelector((state) => state.services);
  const { reportRightSideMode, showReportRightControl, showPaths, reportLeftSideMode } = useAppSelector((state) => state.side);
  const { showContext, contextPosition, showPin, selectLocMode, selectLocFor } = useAppSelector((state) => state.map);

  const dispatch = useDispatch();

  return (
    <>
      {selectLocMode === 1 || selectLocMode === 2 ? (
        <>
          <Stack direction="row" spacing={1} sx={{ position: "absolute", top: "45vh", right: "48.5vw", pointerEvents: "none" }}>
            <Pin />
          </Stack>
        </>
      ) : null}
      {selectLocFor === "add-survay" && selectLocMode > 0 && selectLocMode < 4 ? (
        <>
          <Stack direction="row" spacing={1} sx={{ width: "100%", position: "absolute", bottom: "100px" }}>
            <AddSurvay />
          </Stack>
        </>
      ) : null}
      {selectLocFor === "add-station" && selectLocMode > 0 && selectLocMode < 3 ? (
        <>
          <Stack direction="row" spacing={1} sx={{ width: "100%", position: "absolute", bottom: "100px" }}>
            <AddStation />
          </Stack>
        </>
      ) : null}
      <Stack direction="row" spacing={1} sx={{ width: "30%", position: "absolute", top: LAYOUT_MARGIN, left: "55%" }}>
        {/* <Head /> */}
      </Stack>
      <Box sx={{ position: "absolute", top: LAYOUT_MARGIN, left: LAYOUT_MARGIN, width: "380px", zIndex: "2" }}>
        <Operation />
      </Box>
      <Box sx={{ position: "absolute", top: LAYOUT_MARGIN + 56, left: LAYOUT_MARGIN, width: "380px", zIndex: "2" }}>
        {showPaths ? <ShowPaths /> : null}
        {reportRightSideMode === 1 && !showPaths ? <SortStations /> : null}
        {reportRightSideMode === 2 && !showPaths ? <Inventory /> : null}
        {reportRightSideMode === 3 && !showPaths ? <Tickets /> : null}
      </Box>
      <Box
        sx={{
          position: "absolute",
          top: fullScreen ? 2 : LAYOUT_MARGIN + 56,
          right: LAYOUT_MARGIN,
          width: fullScreen ? `calc(100% - ${LAYOUT_MARGIN * 2}px)` : "400px",
          zIndex: fullScreen ? "1001" : "",
          transition: "all 0.3s",
        }}
      >
        {reportLeftSideMode === 1 ? <SimpleDashboard /> : null}
        {reportLeftSideMode === 2 && !showPaths ? <TicketDetail /> : null}
      </Box>

      <Box sx={{ position: "absolute", top: LAYOUT_MARGIN, right: LAYOUT_MARGIN }}>
        <LocationData />
      </Box>

      <Box sx={{ position: "absolute", top: "50%", right: 0, transform: "translateY(-50%)", zIndex: 1000 }}>
        <Menu />
      </Box>
      {surveyShowType === 0 && surveysVisible && !pointwiseShow ? (
        <Stack direction="row" spacing={1} sx={{ width: "40%", position: "absolute", bottom: 110, left: LAYOUT_MARGIN }}>
          <Spectrum3 />
        </Stack>
      ) : null}
      {surveyShowType === 1 && surveysVisible ? (
        <Stack direction="row" spacing={1} sx={{ width: "40%", position: "absolute", bottom: 110, left: LAYOUT_MARGIN }}>
          <Spectrum2 />
        </Stack>
      ) : null}
      {surveyShowType === 2 && surveysVisible ? (
        <Stack direction="row" spacing={1} sx={{ width: "40%", position: "absolute", bottom: 110, left: LAYOUT_MARGIN }}>
          <Spectrum />
        </Stack>
      ) : null}
      <Stack
        direction="row"
        spacing={1}
        sx={{
          width: `calc(100% - ${LAYOUT_MARGIN * 2}px)`,
          position: "absolute",
          bottom: LAYOUT_MARGIN,
          left: LAYOUT_MARGIN,
        }}
      >
        <RightSideController />
        <Tooltip bgcolor="secondary.main" />
        <Toolbox />
        <LeftSideController />
      </Stack>
      <Modals />
    </>
  );
}
